import React from 'react';

export const RUNNER_EVENTS = new Set([
  'started',
  'created',
  'updated',
  'deleted',
  'soft_deleted',
  'imported',
  'exported',
]);

export const EVENT_LABELS = {
  started: 'Berjalan',
  created: 'Dibuat',
  updated: 'Diperbarui',
  deleted: 'Dihapus',
  soft_deleted: 'Hapus Sementara',
  imported: 'Impor',
  exported: 'Ekspor',
  login: 'Login',
};

export const formatEventLabel = (event) => {
  if (!event) return '-';
  return EVENT_LABELS[event] || event;
};

export const getEventBadgeClass = (event) =>
  event === 'started' ? 'badge-light-warning' : 'badge-light-primary';

export const LogEventBadge = ({ event }) => {
  if (!event) return <span>-</span>;
  return (
    <span className={`badge ${getEventBadgeClass(event)} text-uppercase`}>
      {formatEventLabel(event)}
    </span>
  );
};
